import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitCustomZoneModel } from '@apps-common/types/portal/unit'

export const QUERY_MY_MONITORING_GET_SITE_ZONES = (unitId?: string) => ['getMyMonitoringSiteZones', unitId].filter(Boolean)

const getSiteZones = async (unitId?: string): Promise<IUnitCustomZoneModel[]> =>
  axios.get(`/my-monitoring/sites/GetZones?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSiteZones

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId?: string
}

export const useMyMonitoringGetSiteZones = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MY_MONITORING_GET_SITE_ZONES(unitId),
    queryFn: () => getSiteZones(unitId)
  })
